import { defineStore } from 'pinia';
import { setConsent } from '@/services/consent/consentService';
import { useUserDataStore } from './userDataStore';

interface ConsentState {
  isSaving: boolean;
  errorMessage: string | null;
}

export const useConsentStore = defineStore('consent', {
  state: (): ConsentState => ({
    isSaving: false,
    errorMessage: null,
  }),

  actions: {
    async acceptConsent(termsAccepted: boolean, marketingConsent: boolean) {
      this.isSaving = true;
      this.errorMessage = null;

      try {
        const res = await setConsent(termsAccepted, marketingConsent);

        if (res?.status?.toLowerCase() !== 'success') {
          this.errorMessage = res?.message || 'Something went wrong. Please try again.';
          return false;
        }

        const userDataStore = useUserDataStore();
        if (userDataStore.userInfo) {
          userDataStore.userInfo.consentRequired = false;
          userDataStore.userInfo.marketingConsent = marketingConsent;
        }

        return true;
      } catch (error: any) {
        this.errorMessage = error?.message || 'Something went wrong. Please try again.';
        return false;
      } finally {
        this.isSaving = false;
      }
    },
  },
});
